import * as React from 'react';
import { styled } from '@fluentui/react';
import { TextFieldWithActionBase } from './TextFieldWithAction.base';
import {
    ITextFieldWithActionProps,
    ITextFieldWithActionStyleProps,
    ITextFieldWithActionStyles,
} from './TextFieldWithAction.types';
import { getStyles } from './TextFieldWithAction.styles';

export type ITextFieldWithActionPropsWithRef = React.PropsWithoutRef<ITextFieldWithActionProps> &
    React.RefAttributes<HTMLDivElement>;

export const TextFieldWithAction: React.FunctionComponent<ITextFieldWithActionPropsWithRef> =
    styled<
        ITextFieldWithActionPropsWithRef,
        ITextFieldWithActionStyleProps,
        ITextFieldWithActionStyles
    >(TextFieldWithActionBase, getStyles, undefined, {
        scope: 'TextFieldWithAction',
    });

TextFieldWithAction.displayName = 'TextFieldWithAction';
